import { createI18n } from 'vue-i18n'
import { datetimeFormats } from './datetimeFormats'

// Import locale messages
import en from './locales/en.json'
import it from './locales/it.json'

const messages = {
  en,
  it
}

// Create i18n instance
const i18n = createI18n({
  legacy: false, // Use Composition API mode
  locale: 'en', // Set locale
  fallbackLocale: 'en', // Set fallback locale
  messages,
  datetimeFormats
})

export default i18n